module.exports = __webpack_public_path__ + "media/images/dashboard/colorGold-b00e33d374ec6cd62fbd7296869a2ffd.svg";